var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title-text":_vm.title}},[_c('div',{staticClass:"media-container",attrs:{"slot":"content"},slot:"content"},[_c('img',{attrs:{"src":require("../../assets/images/img_support_media.png"),"draggable":"false"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }